import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { LinkProps } from './Link.types';


export const StyledLink = styled(Link)<LinkProps>`
  && {
    color: ${({ theme }) => theme.color.primary.blue};
    font-weight: ${({ fontWeight }) => fontWeight || 500};
    font-size: ${({ fontSize }) => fontSize || '14px'};
    font-family: Inter;
  }
`;
